import React, {useEffect, useRef, useState} from "react";
import {Flex, rem, Text, Title, Overlay, Box} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";

interface Props {
    staticBaseUrl: string;
}

export default function CarouselOp(props: Props) {
    const autoplay = useRef(Autoplay({delay: 3000}));
    const [initialSlide, setInitialSlide] = useState(0);

    const slides = [
        `${props.staticBaseUrl}alone/images/collection/2.jpg`,
        `${props.staticBaseUrl}alone/images/collection/1.jpg`,
        `${props.staticBaseUrl}alone/images/collection/3.jpg`,
        `${props.staticBaseUrl}alone/images/collection/4.jpg`,
        `${props.staticBaseUrl}alone/images/collection/5.jpg`,
        `${props.staticBaseUrl}alone/images/collection/6.jpg`,
        `${props.staticBaseUrl}alone/images/collection/7.jpg`,
        `${props.staticBaseUrl}alone/images/collection/8.jpg`,
        `${props.staticBaseUrl}alone/images/collection/9.jpg`,
        `${props.staticBaseUrl}alone/images/collection/10.jpg`,
        `${props.staticBaseUrl}alone/images/collection/11.jpg`
    ];

    useEffect(() => {
        setInitialSlide(Math.floor(Math.random() * slides.length));
    }, []);

    return (
        <Box
            style={{
                height: "calc(100svh - 40px)",
                borderRadius: rem(12),
                overflow: "hidden",
                position: "relative",
            }}
        >
            <Carousel
                withIndicators
                height={"100%"}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={() => autoplay.current.play()}
                withControls={false}
                initialSlide={initialSlide}
                emblaOptions={{
                    loop: true
                }}
            >
                {slides.map((slide, idx) => (
                    <Carousel.Slide key={idx}>
                        <Box
                            style={{
                                position: "relative",
                                height: "calc(100svh - 40px)",
                                width: "100%",
                                backgroundImage: `url(${slide})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        >
                            <Overlay
                                gradient="linear-gradient(0deg, rgba(0,0,0,0.7) 20%, transparent 90%)"
                                opacity={1}
                                zIndex={1}
                            />
                        </Box>
                    </Carousel.Slide>
                ))}
            </Carousel>

            <Flex direction={'column'} pos={'absolute'} style={{bottom: '50px'}} align={'center'}>
                <Flex
                    direction="column"
                    gap={rem(16)}
                    justify="flex-end"
                    h="100%"
                    p={rem(40)}
                    style={{zIndex: 2, position: "relative"}}
                >
                    <Title fw={600} fz={rem(30)} lh={rem(40)} c="#FAFAFA">
                        View Best Profile Matches
                    </Title>
                    <Text fw={500} fz={rem(18)} lh={rem(26)} c="#FAFAFA">
                        AI powered online platform to review older person and volunteers matches, based on interests, needs and support criteria.
                    </Text>
                </Flex>
                <Title
                    fw={600}
                    fz={rem(12)}
                    lh={rem(24)}
                    c="#FFFFFF"
                    style={{
                        textAlign: "center",
                        position: "absolute",
                        bottom: rem(4),
                        width: "100%",
                        zIndex: 2,
                    }}
                >
                    Powered by BrightBeam
                </Title>
            </Flex>

        </Box>
    );
}